import React, { useState } from "react";
import axios from "axios";
import { API_URL } from '../../api/api';

import { toast } from "../../utils/toast";
const LeaveTypeModal = ({ isOpen, onClose, onSaved }) => {
  const baseURL =`${API_URL}/api/settings/calendar`; 

  const [formData, setFormData] = useState({
    name: "",
    max_days_per_year: "",
    color: "#ff0000",
  });

  if (!isOpen) return null;

  const handleSave = async () => {
    try {
      await axios.post(`${baseURL}/leave-types`, {
        name: formData.name,
        max_days_per_year: formData.max_days_per_year,
        color: formData.color,
      });

      onSaved();     // 🔥 refresh leave types in parent
      onClose();
    } catch (err) {
      toast.error("Failed to save leave type");
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <div className="modal-bodys">
          <h3>Add Leave Type</h3>

          <div className="form-item">
            <label>Name</label>
            <input
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>

          <div className="form-item">
            <label>Max Days Per Year</label>
            <input
              type="number"
              value={formData.max_days_per_year}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  max_days_per_year: e.target.value,
                })
              }
            />
          </div>

          <div className="form-item color-item">
            <label>Color</label>
            <input
              type="color"
              value={formData.color}
              onChange={(e) =>
                setFormData({ ...formData, color: e.target.value })
              }
            />
          </div>
        </div>

        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button className="orng-fill" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveTypeModal;
